import React from "react";
import LzXMediaBrowser from '@lz/components/commons/Media/Browser';

export interface LzPPageMedia {
    children?: React.ReactNode,
}

const LzXPageMedia = (props: LzPPageMedia) => {

    return (
        <React.Fragment>
            {props.children ?
                props.children
                :
                <LzXMediaBrowser
                />
            }
        </React.Fragment>
    );
};

export default LzXPageMedia;
